import React from 'react';
import { Link } from 'react-router-dom';

export const DownloadGuidePage: React.FC = () => {
  return (
    <main className="main-content">
      <div className="container" style={{ maxWidth: '800px', padding: '60px 20px' }}>
        <div className="guide-card" style={{
          backgroundColor: '#fff',
          borderRadius: '12px',
          boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
          padding: '40px',
          textAlign: 'center'
        }}>
          <div className="guide-icon" style={{ fontSize: '4rem', marginBottom: '20px' }}>🔐</div>
          <h1 style={{ fontSize: '2rem', marginBottom: '20px', color: '#333' }}>資料ダウンロード</h1>
          
          <div className="guide-content" style={{ textAlign: 'left', marginBottom: '40px', lineHeight: '1.8' }}>
            <p style={{ fontSize: '1.1rem', marginBottom: '20px' }}>
              WiCanvasの取扱説明書や詳細な技術資料を閲覧・ダウンロードするには、<strong>専用のアカウント（ID・パスワード）</strong>が必要です。
            </p>
            
            <div style={{ backgroundColor: '#f8f9fa', padding: '20px', borderRadius: '8px', borderLeft: '4px solid #007bff' }}>
              <h2 style={{ fontSize: '1.1rem', marginBottom: '10px' }}>アカウントをお持ちでない方</h2>
              <p>
                アカウントは、
                <a href="/#contact" style={{ color: '#007bff', textDecoration: 'underline', fontWeight: 'bold' }}>お問い合わせフォーム</a>
                よりお申し込みいただいた後、弊社担当より発行させていただきます。
                内容を確認の上、順次対応しておりますので、お手元に届くまでしばらくお待ちください。
              </p>
            </div>
            
            <p style={{ marginTop: '20px', fontSize: '0.95rem', color: '#666' }}>
              ※ アカウントをお持ちの方は、下のボタンをクリックした後に表示される認証画面にて、IDとパスワードを入力してください。
            </p>
          </div>

          <div className="guide-actions" style={{ display: 'flex', gap: '20px', justifyContent: 'center' }}>
            <a href="/download" className="btn btn-primary btn-large" style={{ padding: '15px 40px', fontSize: '1.1rem' }}>
              ログインしてダウンロードページへ
            </a>
            <Link to="/" className="btn btn-outline btn-large" style={{ padding: '15px 40px', fontSize: '1.1rem' }}>
              トップページへ戻る
            </Link>
          </div>
        </div>
      </div>
    </main>
  );
};
